export const types = [
  {
    key: 'thirdpartyProperty',
    label: 'thirdpartyRight.types.thirdpartyProperty',
  },
  {
    key: 'retentionOfTitle',
    label: 'thirdpartyRight.types.retentionOfTitle',
  },
  {
    key: 'loan',
    label: 'thirdpartyRight.types.loan',
  },
  {
    key: 'credit',
    label: 'thirdpartyRight.types.credit',
  },
  {
    key: 'leasing',
    label: 'thirdpartyRight.types.leasing',
  },
  {
    key: 'rent',
    label: 'thirdpartyRight.types.rent',
  },
  {
    key: 'hirePurchase',
    label: 'thirdpartyRight.types.hirePurchase',
  },
  {
    key: 'extendedRetentionOfTitle',
    label: 'thirdpartyRight.types.extendedRetentionOfTitle',
  },
  {
    key: 'financing',
    label: 'thirdpartyRight.types.financing',
  },
  {
    key: 'mortgagesAccessoryLiability',
    label: 'thirdpartyRight.types.mortgagesAccessoryLiability',
  },
  {
    key: 'commercialRightsOfRetention',
    label: 'thirdpartyRight.types.commercialRightsOfRetention',
  },
  {
    key: 'distraint',
    label: 'thirdpartyRight.types.distraint',
  },
  {
    key: 'freightForwardingLien',
    label: 'thirdpartyRight.types.freightForwardingLien',
  },
  {
    key: 'collateralAssignment',
    label: 'thirdpartyRight.types.collateralAssignment',
  },
  {
    key: 'assignmentForSecurity',
    label: 'thirdpartyRight.types.assignmentForSecurity',
  },
  {
    key: 'landlordsLien',
    label: 'thirdpartyRight.types.landlordsLien',
  },
  {
    key: 'pledge',
    label: 'thirdpartyRight.types.pledge',
  },
  {
    key: 'spatialSecurityTransfer',
    label: 'thirdpartyRight.types.spatialSecurityTransfer',
  },
];
